<template>
  <div class="fixed flex inset-0 z-10 bg-black bg-opacity-75">
    <div class="flex self-center items-center justify-center w-full h-full p-8">
      <div
        class="
          flex flex-col
          overflow-hidden
          bg-white
          rounded
          w-full
          max-h-full max-w-4xl
        "
        :class="width"
      >
        <!-- Header -->
        <div class="flex items-center justify-between p-6 border-b">
          <slot name="header"> This is the default title! </slot>
          <button
            type="button"
            class="btn-close text-3xl outline-none focus:outline-none"
            @click="close"
          >
            x
          </button>
        </div>

        <!-- Content -->
        <div class="relative overflow-y-auto p-6">
          <slot name="body"> This is the default body! </slot>
        </div>

        <!-- Footer -->
        <div class="flex items-center justify-end p-6 border-t">
          <Btn class="mr-2" @onClick="close"> {{ ___("General|Close|content") }}</Btn>
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script >
import Btn from "@/Components/Btn";

export default {
  name: "Modal",
  components: {
    Btn,
  },
  props: {
    width: String,
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>
